// src/lib/test-engine/spr-answer.ts
//
// Re-export. THE implementation of SPR (grid-in) grading lives in
// packages/core/src/spr-answer.ts, so the mobile app and the website grade a
// typed answer with the same code. Importers of this path are unaffected.
// Nothing else in the codebase may compare a typed answer to a key by hand
// (src/lib/__tests__/spr-grading-single-source.test.ts).

export {
  parseSprNumber,
  sprCapacityDecimals,
  sprRequiredDecimals,
  gradeSpr,
  gradeSubmittedAnswer,
  compareSprAnswer,
  normalizeSpr,
  describeSprPrecisionMiss,
  type SprPrecisionMiss,
} from '@unlimitedtests/core'
